import { render } from "./ResultadoDRE.vue?vue&type=template&id=3c4df11f&scoped=true&ts=true"
import script from "./ResultadoDRE.vue?vue&type=script&lang=ts"
export * from "./ResultadoDRE.vue?vue&type=script&lang=ts"

import "./ResultadoDRE.vue?vue&type=style&index=0&id=3c4df11f&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c4df11f"]])

export default __exports__